export default "__VITE_ASSET__f13fdf32__"